import React from 'react';
import { create } from 'jss';
import rtl from 'jss-rtl';
import {
  StylesProvider,
  ThemeProvider,
  jssPreset,
  responsiveFontSizes,
  createMuiTheme,
} from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import blueGrey from '@material-ui/core/colors/blueGrey';
import { CssBaseline } from '@material-ui/core';
import { faLocale } from './langs/fa/moment';
import moment from 'moment-jalaali';

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
let theme = createMuiTheme({
  palette: {
    primary: blueGrey,
    secondary: blue,
    type: 'light',
  },
  direction: 'rtl',
  fontSize: '12px',
  typography: {
    fontFamily: 'IRANSans',
    fontSize: 14,
    subtitle1: {
      fontSize: '18px',
      fontWeight: 'bold',
    },
    subtitle2: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: 'gray',
    },
    h1: {
      fontSize: '24px',
      fontWeight: 'bold',
    },
    h2: {
      fontSize: '20px',
      fontWeight: 'bold',
    },
    h3: {
      fontSize: '18px',
      fontWeight: 'bold',
    },
    h4: {
      fontSize: '16px',
      fontWeight: 'bold',
    },
    h5: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
  },
  spacing: 10,
});
theme = responsiveFontSizes(theme);
moment.locale('fa', faLocale);
moment.loadPersian();
function RTL(props) {
  return (
    <StylesProvider jss={jss}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </StylesProvider>
  );
}
export default RTL;
